import {
  type Product,
  getFirstAttributeValue,
  getProductAndSiblingsColors,
  getProductSiblings,
} from '@scayle/storefront-nuxt'

export default (productItem: MaybeRefOrGetter<Product | undefined | null>) => {
  const product = toRef(productItem)
  const { getProductDetailRoute } = useRouteHelpers()

  const brand = computed(() => {
    return getFirstAttributeValue(product.value?.attributes, 'brand')?.label
  })

  const name = computed(() => {
    return (
      getFirstAttributeValue(product.value?.attributes, 'name')?.label ?? ''
    )
  })

  const price = computed(() => {
    return product.value
      ? getLowestPriceBetweenVariants(product.value)
      : undefined
  })

  const variantWithLowestPrice = computed(() =>
    getVariantWithLowestPrice(product.value?.variants || []),
  )

  const lowestPriorPrice = computed(() => {
    return variantWithLowestPrice.value?.lowestPriorPrice
  })

  const colors = computed(() => {
    return product.value
      ? getProductAndSiblingsColors(product.value, 'color')
      : undefined
  })

  const image = computed(() => {
    return getImageFromList(
      product.value?.images ?? [],
      ProductImageType.BUST,
      'front',
    )
  })

  const siblings = computed(() => {
    return getProductSiblings(product.value, 'color') || []
  })

  const link = computed(() =>
    product.value ? getProductDetailRoute(product.value) : undefined,
  )

  return {
    brand,
    name,
    price,
    lowestPriorPrice,
    colors,
    image,
    siblings,
    link,
    variantWithLowestPrice,
  }
}
